import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import type { ReviewPill } from 'types/vendor';
import Styles from './ReviewFeaturesList.scss';

interface ReviewFeaturesListProps {
	pills: ReviewPill[];
}

interface FeatureProps {
	topicName: string;
}

const Feature = ({ topicName }: FeatureProps): JSX.Element => (
	<div className={Styles.attributeRow} data-testid="review-feature-row">
		<Icon
			name="check-mini"
			size="sm"
			aria-hidden={true}
			aria-label="review-feature-checkmark"
			data-testid="review-feature-checkmark"
			color="success"
		/>
		<TextBody size="sm" color="subtle-dark">
			{topicName}
		</TextBody>
	</div>
);

export const ReviewFeaturesList = ({
	pills,
}: ReviewFeaturesListProps): JSX.Element => {
	return (
		<div className={Styles.reviewFeaturesList}>
			<TextBody
				size="md"
				bold
				data-testid="review-snippets-feature-list-heading"
			>
				Praised by couples for:
			</TextBody>
			<div className={Styles.attributesList}>
				{pills.slice(0, 3).map((pill) => (
					<Feature
						key={`${pill.topicId}-${pill.position}`}
						topicName={pill.topicName}
					/>
				))}
			</div>
		</div>
	);
};
